import { Injectable } from '@angular/core';
import { TRANSLATION_KEYS } from '@core/constants';
import {
  CollectionNoticeStatus,
  CollectionNoticeStatusModel,
} from '@core/models';
import { camelizeData } from '@core/utils';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class CollectionNoticeFilterService {
  constructor(private translateService: TranslateService) {}

  public getCollectioNoticeStatusFilter(): CollectionNoticeStatusModel[] {
    return camelizeData([
      {
        name: 'Pagado',
        status: CollectionNoticeStatus.PAID,
        id: CollectionNoticeStatus.PAID,
      },
      {
        name: 'Pendiente',
        status: CollectionNoticeStatus.PENDING,
        id: CollectionNoticeStatus.PENDING,
      },
      {
        name: 'Vencido',
        status: CollectionNoticeStatus.EXPIRED,
        id: CollectionNoticeStatus.EXPIRED,
      },
      {
        name: this.translateService.instant(
          TRANSLATION_KEYS.LABELS.COLLECTION_NOTICE_CANCEL_STATUS
        ),
        status: CollectionNoticeStatus.CANCELLED,
        id: CollectionNoticeStatus.CANCELLED,
      },
      {
        name: 'En Proceso de Pago',
        status: CollectionNoticeStatus.IN_PAYMENT_PROCESS,
        id: CollectionNoticeStatus.IN_PAYMENT_PROCESS,
      },
      {
        name: 'Devolución Pendiente',
        status: CollectionNoticeStatus.PENDING_REFUND,
        id: CollectionNoticeStatus.PENDING_REFUND,
      },
      {
        name: 'Devuelto',
        status: CollectionNoticeStatus.REFUND,
        id: CollectionNoticeStatus.REFUND,
      },
      {
        name: 'Pendiente Por Contracargo',
        status: CollectionNoticeStatus.PENDING_CHARGE_BACK,
        id: CollectionNoticeStatus.PENDING_CHARGE_BACK,
      },
      {
        name: 'Pago en Validacion',
        status: CollectionNoticeStatus.PAYMENT_VALIDATION,
        id: CollectionNoticeStatus.PAYMENT_VALIDATION,
      },
      {
        name: 'Inicializando Pago',
        status: CollectionNoticeStatus.INITIALIZING_PAYMENT,
        id: CollectionNoticeStatus.INITIALIZING_PAYMENT,
      },
    ]);
  }
}
